import React from "react";
import { Card, TextField, Button, Icon } from "@shopify/polaris";
import { Flex } from "rebass";
import { ClipboardMinor } from "@shopify/polaris-icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useShop } from "providers/ShopProvider";
import { useToast } from "providers/ToastProvider";

// Returns the URL the customer received in their email/SMS — honoring the
// merchant's custom flow URL setting when one is configured, otherwise the
// default Verdict-hosted flow.
function resolveCheckUrl(check, shop) {
  if (!check?.id) return "";
  const template = shop?.settings?.customFlowUrl;
  if (template) {
    return template.replace("{{checkId}}", check.id);
  }
  return `https://verify.getverdict.com/${check.id}`;
}

export default function CheckLinkCard({ check }) {
  const { shop } = useShop();
  const setToast = useToast();

  if (!check?.id) return null;

  const url = resolveCheckUrl(check, shop);

  return (
    <Card title="ID check link">
      <Card.Section>
        <TextField
          autoComplete="off"
          value={url}
          readOnly
          label=""
          helpText="This is the same link that was sent to the customer"
          connectedRight={
            <CopyToClipboard
              text={url}
              onCopy={() => setToast("ID Check URL copied.")}
            >
              <Button>
                <Flex alignItems="center">
                  <Icon source={ClipboardMinor} />
                  &nbsp; Copy
                </Flex>
              </Button>
            </CopyToClipboard>
          }
        />
      </Card.Section>
    </Card>
  );
}
